/**
 * @desc 站点课程方大图模块
 */
const webSiteOrgBannerList = r => require.ensure([], () => r(require('../views/webSiteOrgBanner/WebSiteOrgBannerList.vue')), 'webSiteOrgBannerList');

export default [
  //站点广告列表
  {
    name: 'webSiteOrgBannerList',
    path: '/webSiteOrgBannerList',
    component: webSiteOrgBannerList,
    meta: { title: '课程方大图' },
  },
]